import { render, staticRenderFns } from "./SPXKZ.vue?vue&type=template&id=9cb31e3c&scoped=true&"
import script from "./SPXKZ.vue?vue&type=script&lang=js&"
export * from "./SPXKZ.vue?vue&type=script&lang=js&"
import style0 from "./SPXKZ.vue?vue&type=style&index=0&id=9cb31e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb31e3c",
  null
  
)

export default component.exports